export function getRugTypeID(rugType) {
    switch (rugType) {
        case "lachak-toranj":
            return 1
        case "afshan":
			return 2
		case "modern":
			return 4
		case "kheshti":
			return 3
        default:
            return 0
    }
}